import { QueryClient } from '@tanstack/react-query'
import { createContext } from 'react'

export const cachedNotesContext = createContext<QueryClient | undefined>(
  undefined
)
